import { NgModule } from '@angular/core';
import { CommonModule } from "@angular/common";
import { RetailTableDataModule } from "../services/retail-table-data/retail-table-data.module";
import { RetailGridComponent } from "./retail-grid.component";
import { MatTableModule } from "@angular/material/table";
import { PriceModule } from "libraries/component/price/price.module";
import { QuotationQuotationsResourceModule } from "libraries/service/resources/quotation-quotations/quotation-quotations-resource.module";
import { ConfigurationResourceModule } from "libraries/service/resources/configuration/configurationResource.module";
import { ColEndModule } from "app_quotation/shared/components/table/col-end/col-end.module";
import { ThTextModule } from "libraries/component/table/th-text/th-text.module";
import { TdContainerBlockContentModule } from "./components/td-container-block-content/td-container-block-content.module";
import { ThPriceModule } from "app_quotation/shared/components/table/th-price/th-price.module";
import { TdPriceModule } from "libraries/component/table/td-price/td-price.module";
import { TdAdjustmentModule } from "app_quotation/shared/components/table/td-adjustment/td-adjustment.module";
import { ThTravellerModule } from "app_quotation/shared/components/table/th-traveller/th-traveller.module";
import { CellTotalMarginModule } from "./components/cell-total-margin/cell-total-margin.module";
import { CellBlockMarginModule } from "../../../../libraries/component/table/cell-block-margin/cell-block-margin.module";
import { CellPriceModule } from 'libraries/component/table/cell-price/cell-price.module';
import { CellAdjustmentModule } from './components/cell-adjustement/cell-adjustment.module';
import { ErrorTracingModule } from 'libraries/service/error-tracing/error-tracing.module';
import { QuotationPricePipesModule } from "app_quotation/shared/pipes/quotation-price-pipes.module";
import { ThTotalWithVatConfigurationModule } from "./components/th-vat-configuration/th-total-with-vat-configuration.module";
import { RetailAccordingToVatPipe } from "./pipes/retail-according-to-vat.pipe";
import { GetVatConfigurationPipe } from './pipes/get-vat-configuration.pipe';

@NgModule({
    imports: [
        TdPriceModule,
        TdAdjustmentModule,
        CommonModule,
        ConfigurationResourceModule,
        ColEndModule,
        ThTravellerModule,
        ThPriceModule,
        MatTableModule,
        PriceModule,
        QuotationQuotationsResourceModule,
        TdContainerBlockContentModule,
        CellPriceModule,
        CellAdjustmentModule,
        CellTotalMarginModule,
        RetailTableDataModule,
        CellBlockMarginModule,
        ThTextModule,
        ErrorTracingModule,
        QuotationPricePipesModule,
        ThTotalWithVatConfigurationModule,
    ],
    exports: [
        RetailGridComponent,
    ],
    declarations: [
        RetailGridComponent,
        RetailAccordingToVatPipe,
        GetVatConfigurationPipe,
    ],
})
export class RetailGridModule {
}
